<template>
  <router-link :to="{name: 'tag', params: {language: language, slug: slug}}"
               class='tag-item'>
    <span v-if='language === "en" && description'
          v-html='description'></span>
    <span v-else
          v-html='name'></span>
  </router-link>
</template>

<script>
export default {
  name: 'dsTagItemInline',
  props: ['tag', 'tags', 'language'],
  data() {
    return {
      name: '',
      slug: '',
      description: ''
    }
  },
  created() {
    if (this.tags) {
      let tempTag = this.tags.findOne({
        id: this.tag
      })
      if (tempTag) {
        this.name = tempTag.name
        this.slug = tempTag.slug
        this.description = tempTag.description
      }
    }
  }
}
</script>

<style lang='scss' scoped>
@import '../styles/helpers/_mixins.scss';
@import '../styles/responsive/_manager.scss';
@import '../styles/_variables.scss';
@import '../styles/_space.scss';
@import '../styles/_color.scss';

.tag-item {
  display: inline;
  text-transform: uppercase;
  text-decoration: none;
  border: 0;
  color: $secondary-color;
  &:visited {
    color: $secondary-color;
  }
  &:hover {
    color: $main-color;
    text-decoration: none;
    border: none;
  }
  &::after {
    content: ', ';
  }
  &:last-child {
    &::after {
      content: '';
    }
  }
}
</style>



// WEBPACK FOOTER //
// dsTagItemInline.vue?ed1ddb54